<template>
	<div id="cart-recovered-notice" class="active animated bounceIn" @click="$store.state.showCartRecoveredNotice = false">
		<span>היי, יש לך פריטים בעגלה מהביקור האחרון.</span>
		<u>OK</u>
	</div>
</template>

<script>
	export default {

		name: 'CartRecoveredNotice',

		data () {
			return {
			
			}
		},
		computed: {
			active() { return this.$store.state.showCartRecoveredNotice; }
		},
		mounted() {
			setTimeout( e => {
				this.$store.state.showCartRecoveredNotice = false;
			}, 8000);
		}
	}
</script>

<style lang="sass" scoped>
	#cart-recovered-notice
		position: absolute
		top: 6.85rem
		left: 1rem
		background-color: #ea4726
		color: white
		padding: 0.75rem 1rem
		box-shadow: 0 0.5rem 1rem rgba(darken(#ea4726, 10%), 0.3)
		border-radius: 0.25rem
		z-index: 4
		opacity: 0
		transform: scale(0)
		white-space: nowrap
		font-size: 0.75rem
		cursor: pointer
		&:before
			content: ''
			width: 0
			height: 0
			border-left: 0.4rem solid transparent
			border-right: 0.4rem solid transparent
			border-bottom: 0.4rem solid #ea4726
			position: absolute
			top: -0.4rem
			left: 2.75rem

		&.active.animated.bounceIn
			opacity: 1
			transform: scale(1)

		u
			background-color: transparent
			border: none
			outline: none
			text-decoration: underline
			margin-right: 10px
	
	// Tablet
	@media screen and (max-width: 1350px)
		#cart-recovered-notice
			top: 5rem
			&:before
				left: 2rem

	// Mobile
	@media screen and (max-width: 800px)
		#cart-recovered-notice
			font-size: 0.85rem
			top: 3.5rem
			&:before
				left: 1.15rem
</style>